module.exports = __webpack_public_path__ + "img/silver_full.78231bb5.svg";